import useComputedToggle from '@nicolaudie-group/ng-ui-kit/composables/useComputedToggle'
import useQuerySync from '@/composables/useQuerySync'
import { watch } from 'vue'

const parse = (value) => Boolean.from(value)
const serialize = (value) => (value ? String(value) : undefined)

/**
 * immediate: true = the initial value will override the query (default)
 * immediate: false = the initial value will take the value of the query
 */
function useQueryToggle(key, { initial = false, setter, immediate = true } = {}) {
  const queryState = useQuerySync(key, { initial, parse, serialize })

  const {
    state,
    toggle,
    set,
    on,
    off,
    // Using a "useComputedToggle" instead of "useToggle" so that changes go through
    // the setter instead of the state being modified directly by "useQuerySync"
  } = useComputedToggle(
    () => queryState.value,
    { setter },
  )

  watch(state, (newState) => {
    queryState.value = newState
  }, { immediate })

  return {
    state,
    toggle,
    set,
    on,
    off,
  }
}

export default useQueryToggle
